import type { DividerFontSchemaType, DividerSchemaType } from '@vedalib/editor/lib/brand'
import type { DividerTypes } from '@vedalib/editor/lib/elements'
import { DividerViews } from '@vedalib/editor/lib/elements'
import cn from 'classnames'
import lodash from 'lodash'

import type { ElementFontCss, ElementStyleCss } from 'services/Branding/types'

import * as s from './Divider.module.scss'

interface IDividerProps {
  styles: ElementStyleCss<DividerSchemaType>
  font: ElementFontCss<DividerFontSchemaType>
  view?: DividerViews
  type: DividerTypes
  isNumbered?: boolean
  number: string | undefined
  isV2?: boolean
}

const DividerBase: React.FC<IDividerProps> = ({
  styles,
  view,
  type,
  number,
  isNumbered,
  font,
  isV2,
}) => {
  const dividerLineStyles = { ...styles.line, ...styles.effects, borderTopStyle: type }

  return (
    <div
      className={cn(s.root, { [s.v2]: isV2 })}
      style={lodash.pick(styles.numbered, ['justifyContent'])}
    >
      <div className={s.lineContainer}>
        <div className={s.divider} style={dividerLineStyles} />
        {view === DividerViews.double && (
          <div className={s.divider} style={{ ...dividerLineStyles, ...styles.double }} />
        )}
      </div>
      {isNumbered && (
        <div
          className={s.number}
          style={{
            ...font.base,
            ...lodash.omit(styles.numbered, ['justifyContent']),
            ...styles.effects,
          }}
        >
          {number}
        </div>
      )}
    </div>
  )
}

export default DividerBase
